import ipynbTemplate from '../templates/ipynb-template.json';

function convertToSource(input: string) {
    return input?.split('\n')?.map((line) => `${line}\n`) || [];
}

function createIpynb({ system, tools, user, toolUse, toolOutput, assistant }:
    { system: string, tools: string, user: string, toolUse: string, toolOutput: string, assistant: string }) {
    ipynbTemplate.cells[0].source = convertToSource(system) as any;
    ipynbTemplate.cells[1].source = convertToSource(tools) as any;
    ipynbTemplate.cells[2].source = convertToSource(user) as any;
    ipynbTemplate.cells[3].source = convertToSource(toolUse) as any;
    ipynbTemplate.cells[4].source = convertToSource(toolOutput) as any;
    ipynbTemplate.cells[5].source = convertToSource(assistant) as any;

    return ipynbTemplate;
}

export default createIpynb